import { Component, OnInit, ViewChild, AfterViewInit, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { NgForm } from '@angular/forms';
import { MainComponent } from '@components/main/main.component';
import { ErrorResponse } from '@models/error.response';
import { FormValidationUtil } from '@utils/form.validation';
import { AppConstant } from '@constants/app.constant';
import { from } from 'rxjs';
import { LocaleSorterPipe } from "@pipes/locale-sorter.pipe";

import { TranslateService } from '@ngx-translate/core';
import { SystemParameter } from "@models/system-parameter";
import swal from 'sweetalert2';
import { CommonService } from '@services/common.service';
import { mergeMap, reduce, switchMap } from 'rxjs/operators';
// import { CKEditor5 } from "@ckeditor/ckeditor5-angular";
import { BinaryFile } from '@app/models/binary-file';
import { BinaryFileService } from '@app/services/binary-file.service';
import * as FileSaver from 'file-saver';
import { HtmlTemplateService } from '@app/services/html-template.service';

declare var toastr: any;

const MAX_HERO_FILE_SIZE: number = 10 * 1024 * 1024;



@Component({
    selector: 'order-report',
    templateUrl: './order-report.component.html',
    styleUrls: ['./order-report.component.scss']
})
export class OrderReportComponent implements OnInit, AfterViewInit {

    isFieldError = FormValidationUtil.isFieldError;
    @ViewChild('documentFileSelect', { static: false }) documentFileSelect: ElementRef;
    @ViewChild('generalSettingForm', { static: false }) modelform: NgForm;
    loading: boolean = false;
    clickedSave: boolean = false;
    systemParametersMap: Map<String, SystemParameter>;

    reportDateRangeStart:string;
    reportDateRangeEnd:string;
    templateCode:string='';
    isValidDateRange: boolean = true;
    isFutureStartTime: boolean = false;
    isValidInputForExport: boolean = true;
    
    downloadFileTypes: string[] = ['xlsx','xls'];
    downloadFileType: string = 'xlsx';

    letterInfoMap: Map<String, BinaryFile>;
    contactLetterKeyFlag: string = '#';
    slaInvoiceKey:string = 'SOLUNG#INVOICING';
    famdInvoiceKey:string = 'FAM_D#INVOICING';
    famsInvoiceKey:string = 'FAM_S#INVOICING';
    famsReceiptKey:string = 'FAM_S#RECEIPT';
    famdReceiptKey:string = 'FAM_D#RECEIPT';

    isOnePageTemplateInputRequire: boolean;
    


    supportedFileType: string[] = ['image/jpeg', 'image/jpg', 'image/png'];

    tab: string = 'general';


    @ViewChild('generalSettingForm', { static: false }) generalSettingForm: NgForm;
    @ViewChild('letterInfoSettingForm', { static: false }) letterInfoSettingForm: NgForm;




    constructor(
        private router: Router,
        public appConstant: AppConstant,
        public commonService: CommonService,
        private mainComponent: MainComponent,
        private translate: TranslateService,
        private htmlService: HtmlTemplateService,
        private binaryFileService: BinaryFileService
    ) {
    }

    ngOnInit(): void {
        console.log('eeeeeeebbbbb');
        this.htmlService.htmlTemplateAmount().subscribe((value:number)=>{
            console.log('feeeeeeeeee>>>>'+value);
            if(value>1){
                this.isOnePageTemplateInputRequire = true;
            }else{
                this.isOnePageTemplateInputRequire = false;
            }
        });
    }

    ngAfterViewInit(): void {

    } 

    onDownloadFileTypeChange(taskType: string) {
        
        this.downloadFileType = taskType;

    }

    isValidateInput(): boolean{
        
        if(this.reportDateRangeStart && !this.reportDateRangeEnd){
            var currd = new Date();
            var d1 = new Date(this.reportDateRangeStart); 
            if(currd.getTime()-60000<d1.getTime()){
                this.isFutureStartTime = true;
                return false;
            }else{
                this.isFutureStartTime = false;
            }
        }

        if(this.reportDateRangeStart && this.reportDateRangeEnd){
            var currd = new Date();
            var d1 = new Date(this.reportDateRangeStart);
            var d2 = new Date(this.reportDateRangeEnd);

            if(currd.getTime()-60000<d1.getTime()){
                this.isFutureStartTime = true;
                return false;
            }else{
                this.isFutureStartTime = false;
            }
            if(d1<d2){
                const diffMs = Math.abs(d2.getTime() - d1.getTime());
                const diffDays = Math.ceil(diffMs / (1000 * 60 * 60 * 24));

                if(diffDays>30){
                    this.isValidDateRange = false;
                }else{
                    this.isValidDateRange = true;
                }

            }else{
                this.isValidDateRange = false;
                return false;
            }
        }
        
        if(this.isOnePageTemplateInputRequire && !this.templateCode){
            this.isValidInputForExport = false;
            return false;
        }

        if(!this.reportDateRangeStart && !this.reportDateRangeEnd && !this.templateCode){
            this.isValidInputForExport = false;
            return false;
        }
        this.isValidInputForExport = true;
        return true;
    }
    public export_report(): void{
        for (let key of Object.keys(this.modelform.controls)) {
            this.modelform.controls[key].markAsDirty();
        }
 
        if (!this.modelform.valid) {
            return;
        }

        if(this.isValidateInput()){
            this.downloadFile();
        }
    }

    fileLoading: boolean = false;

    public dateFormat(dateobj:any, isStart:any=false){
        if(!dateobj){
            return '';
        } 

        if(isStart!=undefined){
            dateobj = new Date(dateobj);
        }

       return this.dateFormat2(dateobj);
    }

    dateFormat2(dateobj){
        var y = dateobj.getFullYear();
        var m = dateobj.getMonth()+1;
        var d = dateobj.getDate();
        var h = dateobj.getHours();
        var mi = dateobj.getMinutes();
        var sec = dateobj.getSeconds();
        // if(isStart){
        //     return y+"-"+(m<10?("0"+m):m)+"-"+(d<10?("0"+d):d)+" 00:00:00";
        // }
        return y+"-"+(m<10?("0"+m):m)+"-"+(d<10?("0"+d):d)+" "+(h<10?("0"+h):h)+":"+(mi<10?("0"+mi):mi)+":"+(sec<10?("0"+sec):sec);
        // return dateobj.toISOString();
    }

    downloadFile() {
        let tm = Date.now();
        let fileName = "order-report-"+this.dateFormat(new Date())+"-"+tm+"."+
                        (this.downloadFileType?this.downloadFileType:"xlsx");
        this.fileLoading = true;
        // item._selected = true;
        const parameterStr = `?templateCode=${this.templateCode}&fromDate=${this.dateFormat(this.reportDateRangeStart,true)}&toDate=${this.dateFormat(this.reportDateRangeEnd, false)}`;
        this.binaryFileService.downloadReport(parameterStr)
            .subscribe(blob => {

            FileSaver.saveAs(blob, fileName);
                this.fileLoading = false;
                // item._selected = false;
            }, (error: ErrorResponse) => {
                this.fileLoading = false;
                // item._selected = false;
                if(error==null){
                    return;
                }
                from(error.errors)
                    .pipe(
                        mergeMap(error => this.translate.get(error.errorCode)),
                        reduce((acc, value) => acc + value + '<br/>', '')
                    )
                    .subscribe(msg => {
                        this.translate.get(fileName)
                            .pipe(
                                switchMap(typeStr => this.translate.get('FAIL_TO_DOWNLOAD', { type: typeStr }))
                            )
                            .subscribe(title => {
                                toastr.options = {
                                    "closeButton": true,
                                    "positionClass": "toast-bottom-right",
                                    "timeOut": "0",
                                    "extendedTimeOut": "0"
                                }
                                toastr.error(msg, title);
                            });
                    });
            })
    }

     
}
